import { html, View } from 'rune-ts';
import klass from '@services/MarppleShop/renderApp/pages/Main/views/DomainBanner/DomainBanner.module.scss';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { replaceNewlinesWithBr } from '@services/MarppleShop/shared/util';
import { DomainBannerType } from '@services/MarppleShop/renderApp/pages/Main/views/DomainBanner/DomainBanner.ts';
import { BannerTypeS } from '@services/MarppleShop/features/Banner/outbound/share.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';
import { makeDefaultProfileImg } from '@services/MarppleShop/shared/util/helper.ts';

interface DomainBannerImageViewOption {
  center_klass: string;
}

const default_img = makeDefaultProfileImg(448);

export class DomainBannerImageViewPC extends View<DomainBannerType[]> {
  center_klass: string;

  constructor(data: DomainBannerType[], option: DomainBannerImageViewOption) {
    super(data);

    this.center_klass = option.center_klass;
  }

  protected override template() {
    return html`
      <div class="${klass.banner_items}">
        ${this.data.map(({ url, category, target, href, title, sub_title, is_center }) => {
          return html`
            <a
              ${href ? html`href = "${html.preventEscape(href)}"` : ''}
              ${href ? html`target="${target}"` : ''}
              class="${klass.banner_item} ${is_center ? this.center_klass : ''}"
            >
              <div class="${klass.image_overlay}"></div>
              <img
                src="${url
                  ? getResizedUrl({
                      url: url ?? '',
                      width: 448 * 2,
                      quality: 85,
                      format: 'webp',
                    })
                  : default_img}"
                class="${klass.image}"
                alt="배너 이미지"
              />
              <div class="${klass.domain} ${staticFont('bebas_20_bold')}">${category}</div>
              <div class="${klass.title_wrapper}">
                <div class="${klass.title} ${font('28_bold')}">
                  ${title ? html.preventEscape(replaceNewlinesWithBr(title)) : ''}
                </div>
                <div class="${klass.desc} ${font('16_medium')}">
                  ${sub_title ? html.preventEscape(replaceNewlinesWithBr(sub_title)) : ''}
                </div>
              </div>
            </a>
          `;
        })}
      </div>
    `;
  }
}

export class DomainBannerImageViewMO extends View<BannerTypeS.MainBannerData> {
  protected override template() {
    const { url, target, href, navigate } = this.data;

    return html`
      <${href ? 'a' : 'div'}
        class="${klass.banner_item}"
        ${navigate ? html`data-post-message="${html.preventEscape(dataStr(navigate))}"` : ''}
        ${href ? html`href = "${html.preventEscape(href)}"` : ''}
        ${href ? html`target="${target}"` : ''}
      >
        <img class="${klass.image}" src="${
          url ? getResizedUrl({ url, width: 2560, quality: 90, format: 'webp' }) : default_img
        }" alt="" />
      </${href ? 'a' : 'div'}>
    `;
  }
}
